import styled from '@emotion/styled';

export const PriceText = styled.p`
    font-size: .8rem;
    font-weight: 600;
    margin-bottom: 0;
`;
